import { createUdzsAuthClient } from "udzs-common/auth";

import { ENV } from "@/env";

export const pipAuthClient = createUdzsAuthClient({
  issuer: ENV.VITE_AUTH_ISSUER,
  clientId: "pip",
  redirectPath: "/oauth/redirect",
  logoutRedirectPath: "/oauth/logout",
  timeReserveMs: 10000,
  localstorageAuthKey: "pip-auth",
  basename: ENV.VITE_BASENAME,
});

export const pipMeApi = `${ENV.VITE_API_BASE_PATH}/me`;
